import { useEffect, useState } from 'react';
import { useSubscriptionInfo } from '@hotjar/subscription-management';

import { isBillingV3Enabled } from '@hotjar/webapp/domains/billing/features';
import { useOwnedAccount } from '@hotjar/account';
import type { SalesSource } from '../utils/salesLinks/salesLinks';
import { getSalesLink } from '../utils/salesLinks/salesLinks';

type BookingFormReturn = {
  openSalesBookingForm: (linkName: SalesSource) => void;
};

/**
 * This hook is used to create a sales link (using `getSalesLink` function) based on wether the customer has an active subscription or not
 */
export const useSalesBookingForm = (): BookingFormReturn => {
  const [hasPaidPlan, setHasPaidPlan] = useState(false);
  const { data: subscriptionInfo } = useSubscriptionInfo();
  const { data: ownedAccount } = useOwnedAccount();
  const isBillingV3 = isBillingV3Enabled(ownedAccount);

  const { customer } = subscriptionInfo || {};

  const hasActiveSubscription = customer?.subscription.status === 'ACTIVE' || hasPaidPlan;

  const openSalesBookingForm = (source: SalesSource) => {
    const salesLinks = getSalesLink(source, hasActiveSubscription ? 'Growth' : 'NewBiz');

    window.open(salesLinks, '_blank', 'noopener noreferrer');
  };

  useEffect(() => {
    if (!ownedAccount || isBillingV3) {
      setHasPaidPlan(false);
    } else {
      setHasPaidPlan(ownedAccount.isCustomer === true && ownedAccount.hasPaidPlan);
    }
  }, [isBillingV3, ownedAccount]);

  return {
    openSalesBookingForm,
  };
};
